<template>
  <el-dialog title="询价单转采购订单" :close-on-click-modal="false" :visible.sync="visible" width="94%" append-to-body>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="90px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="询价单号"><span>{{ inquiryCode }}</span></el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订购日期" prop="orderDate">
            <el-date-picker v-model="dataForm.orderDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="预计生成"><span>{{ poPreviewText }}</span></el-form-item>
        </el-col>
      </el-row>
      <el-table border :data="displayLines" v-loading="linesLoading" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="supplierName" label="供应商" min-width="140" header-align="center" align="left" />
        <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="quantity" label="数量" width="100" header-align="center" align="left" />
        <el-table-column prop="price" label="含税单价" width="110" header-align="center" align="left" />
        <el-table-column prop="tax" label="税点" width="80" header-align="center" align="left" />
        <el-table-column prop="amount" label="行金额" width="100" header-align="center" align="left" />
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :disabled="submitLoading || !displayLines.length" @click="submitHandle">批量生成采购订单</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

export default {
  data() {
    return {
      visible: false,
      submitLoading: false,
      linesLoading: false,
      inquiryId: '',
      inquiryCode: '',
      displayLines: [],
      dataForm: { orderDate: '' },
      dataRule: { orderDate: [{ required: true, message: '订购日期不能为空', trigger: 'change' }] }
    }
  },
  computed: {
    poPreviewText() {
      const n = new Set((this.displayLines || []).map(l => l.supplierId).filter(Boolean)).size
      if (!this.displayLines.length) return '0 张采购订单'
      return n + ' 张采购订单（按供应商拆分）'
    }
  },
  methods: {
    init(inquiryId, inquiryCode) {
      this.inquiryId = inquiryId
      this.inquiryCode = inquiryCode || ''
      this.visible = true
      this.submitLoading = false
      this.displayLines = []
      this.dataForm = { orderDate: today() }
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      this.loadLines()
    },
    loadLines() {
      this.linesLoading = true
      request.get('/purchase/purchaseInquiry/linesForBatchConvert/' + this.inquiryId).then(res => {
        const body = res.data || {}
        const lines = body.list || (Array.isArray(res.data) ? res.data : [])
        if (!lines.length) {
          this.displayLines = []
          this.$message.warning('没有已选中标且未转采购的报价')
          return
        }
        this.displayLines = lines.map(line => {
          const qty = Number(line.quantity)
          const price = Number(line.price)
          return {
            ...line,
            quantity: qty,
            price: price,
            amount: Number((qty * price).toFixed(2))
          }
        })
      }).catch(() => {}).finally(() => { this.linesLoading = false })
    },
    submitHandle() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.displayLines.length) {
          this.$message.warning('没有可转采购明细')
          return
        }
        this.submitLoading = true
        request.post('/purchase/purchaseInquiry/batchConvertToPo', { inquiryId: this.inquiryId, orderDate: this.dataForm.orderDate }).then(() => {
          this.$message.success('已生成采购订单（开立状态，请至采购订单确认）')
          this.visible = false
          this.$emit('success')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    }
  }
}
</script>
